const scrollableHeaderScrollWidth = 300;
const enableScrollRightClass = 'scrollableHeader__inner--scrollRight';
const enableScrollLeftClass = 'scrollableHeader__inner--scrollLeft';

export function initScrollableHeader() {
  const scrollHeader = document.querySelector('.js-scrollableHeader') as HTMLElement;

  if (!scrollHeader) {
    return;
  }

  // wait for correct rendering to calculate width
  window.setTimeout(
    () => {
      addScrollableHeader(scrollHeader);
      initTabHeader(scrollHeader);
      window.addEventListener('resize', () => {
        initTabHeader(scrollHeader);
      });
    },
    200);
}

function addScrollableHeader(scrollHeader: HTMLElement) {
  const scrollHeaderInner = scrollHeader.querySelector('.js-scrollableInnerScroll');

  if (!(scrollHeaderInner instanceof HTMLElement)) {
    return;
  }
  if (scrollHeaderInner.clientWidth < scrollHeaderInner.scrollWidth) {
    scrollHeaderInner.parentElement?.classList.add(enableScrollRightClass);
  } else {
    scrollHeaderInner.parentElement?.classList.remove(enableScrollRightClass);
  }

  scrollHeaderInner.addEventListener('scroll', () => {
    if (scrollHeaderInner.scrollLeft === 0) {
      // scroll position: total left
      scrollHeaderInner.parentElement?.classList.remove(enableScrollLeftClass);
    } else if (scrollHeaderInner.scrollWidth - scrollHeaderInner.clientWidth - scrollHeaderInner.scrollLeft <= 1) {
      // scroll position: total right
      scrollHeaderInner.parentElement?.classList.remove(enableScrollRightClass);
    } else {
      // scroll position: somewhere in between
      scrollHeaderInner.parentElement?.classList.add(enableScrollRightClass);
      scrollHeaderInner.parentElement?.classList.add(enableScrollLeftClass);
    }
  });
  scrollHeader.querySelector('.js-scrollableHeaderScrollLeft')?.addEventListener('click', () => {
    if (scrollHeaderInner instanceof HTMLElement) {
      scrollHeaderInner.classList.remove('submenu__item--scrollRight');
      scrollHeaderInner.scrollLeft -= scrollableHeaderScrollWidth;
    }
  });
  scrollHeader.querySelector('.js-scrollableHeaderScrollRight')?.addEventListener('click', () => {
    if (scrollHeaderInner instanceof HTMLElement) {
      scrollHeaderInner.classList.add('submenu__item--scrollRight');
      scrollHeaderInner.scrollLeft += scrollableHeaderScrollWidth;
    }
  });
  const leftScroll: HTMLElement | null = scrollHeader.querySelector('.js-scrollableHeaderScrollLeft');
  const startItem: HTMLElement | null = scrollHeader.querySelector('.js-submenu-startItem');
  let pos = 0;
  if (leftScroll && startItem) {
    pos = startItem.clientWidth - 31;
    leftScroll.style.left = pos + 'px';
  }
  const itemToScrollTo: HTMLElement | null = scrollHeader.querySelector('.js-itemToScrollTo');
  if (itemToScrollTo) {
    scrollIfNeccessary(itemToScrollTo, scrollHeader, pos);
  }
}

function initTabHeader(tabWrapper: HTMLElement) {
  const tabHeader = tabWrapper.querySelector('.js-scrollableInnerScroll');
  if (!(tabHeader instanceof HTMLElement)) {
    return;
  }
  if (tabHeader.clientWidth < tabHeader.scrollWidth) {
    tabHeader.parentElement?.classList.add(enableScrollRightClass);
  } else {
    tabHeader.parentElement?.classList.remove(enableScrollRightClass);
  }
}

function scrollIfNeccessary(itemToScrollTo: HTMLElement, scrollHeader: HTMLElement, leftMargin: number) {
  const tabHeader = scrollHeader.querySelector('.js-scrollableInnerScroll');
  if (!(tabHeader instanceof HTMLElement)) {
    return;
  }
  if (itemToScrollTo.getBoundingClientRect().left - leftMargin - 200 > tabHeader.clientWidth) {
    const rightScrollButton: HTMLButtonElement | null = scrollHeader.querySelector('.js-scrollableHeaderScrollRight');
    const scrollHeaderInner = scrollHeader.querySelector('.js-scrollableInnerScroll');
    if (!rightScrollButton || !scrollHeaderInner) {
      return;
    }
    scrollHeaderInner.classList.add('submenu__item--scrollRight');
    scrollHeaderInner.scrollLeft += scrollableHeaderScrollWidth;
    window.setTimeout(
      () => {
        scrollIfNeccessary(itemToScrollTo, scrollHeader, leftMargin);
      },
      100,
    );
  }
}
